import React from 'react'
import "./Header_2.css"

function Header_2() {
  return (
  <>
  <section className='Header_2'>
    <div className='img_holder'>
        <img src="/assets/images/header_2/header_2.png" className='header_2_img' alt=" header 2 "/>
    </div>
  </section>
  </>
  )
}

export default Header_2